<template>
  <div class="sidebar-container">
    <ul>
      <li>
        <router-link to="/">
          <img src="@/assets/logo-alt.png" />
        </router-link>
      </li>
      <li v-for="route of routes" :class="{active: $route.path.replace('/dashboard-grfa/', '') == route.path}" :key="route.name">
        <router-link :to="{path: '/dashboard-grfa/' + route.path}">
          <font-awesome-icon :icon="route.meta.icon" class="icon"></font-awesome-icon>
          {{route.meta.title}}
        </router-link>
      </li>
      <li>
        <a :href="alertesUrl" target="_blank">
          <font-awesome-icon :icon="['fas', 'bell']" class="icon"></font-awesome-icon>
          Alertes
        </a>
      </li>
      <li>
        <a :href="cubeCAUrl" target="_blank">
          <font-awesome-icon :icon="['fas', 'cube']" class="icon"></font-awesome-icon>
          Cube CA
        </a>
      </li>
      <li>
        <a target="_blank" :href="'https://maps.cmem-mat.info/?login=' + login + '&email=' + email + '&autologinHash=' + autologinHash + '&odw=1'">
          <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon"></font-awesome-icon>
          Maps
        </a>
      </li>
      <li>
        <a :href="droneUrl" target="_blank">
          <font-awesome-icon :icon="['fab', 'phoenix-squadron']" class="icon"></font-awesome-icon>
          DRONE
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import {getIntraRedirectUrl, getDroneRedirectUrl} from "@/helpers/getRedirectUrlHelper";

  export default {
    name: "GrfaSidebar",
    props: ["year"],
    data() {
      return {
        routes: [],
        login: "",
        email: "",
        autologinHash: ""
      }
    },
    computed: {
      cubeCAUrl() {
        return getIntraRedirectUrl("~/Pages/Reporting/AnalysisTD.aspx?Report=Detaille");
      },
      alertesUrl() {
        return getDroneRedirectUrl("rfa-simulator");
      },
      droneUrl() {
        return getDroneRedirectUrl("dashboard");
      }
    },
    mounted() {
      this.login = new URL(window.location.href).searchParams.get("login");
      this.email = new URL(window.location.href).searchParams.get("email");
      this.autologinHash = new URL(window.location.href).searchParams.get("autologinHash");

      const dashboardRoute = this.$router.options.routes.find(r => r.path == "/dashboard-grfa");
      if (!dashboardRoute) return;
      this.routes = dashboardRoute.children;
    }
  }
</script>

<style scoped>
  .sidebar-container {
    height: 100%;
    max-height: 100vh;
    overflow-y: auto;
    background-color: white;
    padding: 12px 8px;
    position: sticky;
    top: 0;
  }

  ul {
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

  li {
    margin: 0;
    padding: 0;
    width: 100%;
    font-size: 16px;
  }
  li a {
    text-decoration: none;
    color: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    transition: all ease 230ms;
  }

  li img {
    max-width: 75%;
    margin-bottom: 32px;
  }

  li .icon, li svg {
    width: 24px;
    height: auto;
    color: #CCC;
    transition: all ease 230ms;
  }

    li:hover,
    li:hover .icon,
    li.active,
    li.active .icon {
      color: #7ED321;
    }
</style>



// WEBPACK FOOTER //
// src/components/DashboardGRFA/GrfaSidebar.vue